export enum TipoAgrupamento {
  CIDADE = 'CIDADE',
  ROTA = 'ROTA',
  RCA = 'RCA',
  PRACA = 'PRACA',
  REGIAO = 'REGIAO',
  TRANSPORTADORA = 'TRANSPORTADORA',
  AREA_ATENDIMENTO = 'AREA_ATENDIMENTO'
}
